import * as THREE from "three";
import { ConvexGeometry } from 'three/addons/geometries/ConvexGeometry.js';
import { Text } from '@react-three/drei';
import { TubeCurve } from '../shape/Spline';
import React, { memo, useState, useEffect, useRef } from 'react';
import Delaunator from 'delaunator'

import { 
  findClosestPointOnPoints,
} from '../shape/utils';

import { scale3Dpoints, offsetPointsWithBufferGeometryNormal } from "../shape/utils/points";
import { sideSurfaceGeometryfromTwoCurves } from "../shape/utils/surface";



/**
 * Modify mesh for interferance/gap modification
 */
export const MModify = memo(({
  oriMeshSocket,
  pointsIs,
  pointsOs,
  depths,
  smooths,
  normal,
  callback,
  color,
  colorHigh,
  colorSub
}) => {
  console.log("MModify Local");

  const objects = [];
  let key = 0;
  const divCurvePoints = 100;
  const material = new THREE.MeshBasicMaterial( { color: color, side: THREE.DoubleSide, transparent: true, opacity: 0.5 } )
  const materialWireframe = new THREE.MeshBasicMaterial( { color: color, side: THREE.DoubleSide, transparent: true, opacity: 0.5, wireframe:true } )
  const materialHigh = new THREE.MeshBasicMaterial( { color: colorHigh, side: THREE.DoubleSide, transparent: true, opacity: 0.5, wireframe:true } )

  if (!pointsIs) return;
  if (!pointsOs) return;
  if (!depths) return;

  if (!oriMeshSocket) return;
  const meshSocket = oriMeshSocket.clone();
  meshSocket.geometry = oriMeshSocket.geometry.clone(); // for deepcopy
  meshSocket.geometry.computeVertexNormals();

  for (let i = 0; i < pointsIs.length; i++) {
    console.log(i)
    const offset = 20;

    const depth = depths[i];
    const smooth = smooths[i];

    if (depth == 0) continue;
    
    //const pointsI = pointsIs[i];
    // scale curveOuter
    const scale = 1 - smooth/10 + 0.0001 // 0.2;
    const pointsI = scale3Dpoints(pointsIs[i], scale);
    const pointsIsmooth = new THREE.CatmullRomCurve3(pointsI, true).getSpacedPoints(divCurvePoints);
    
    const pointsO = pointsOs[i];
    const pointsOsmooth = new THREE.CatmullRomCurve3(pointsO, true).getSpacedPoints(divCurvePoints);
    
    // if (i != 0) {
    //   continue
    // }

    if (!pointsI) continue;
    if (!pointsO) continue;

    // calc offset points for inside curve to find points inside the inside curve
    const offsetFrontPointsI = offsetPointsWithBufferGeometryNormal(pointsIsmooth, meshSocket.geometry, offset) // pointsIsmooth.map(p => new THREE.Vector3(p.x + offsetX, p.y, p.z + offsetZ));
    const offsetBackPointsI = offsetPointsWithBufferGeometryNormal(pointsIsmooth, meshSocket.geometry, -offset) // pointsIsmooth.map(p => new THREE.Vector3(p.x - offsetX, p.y, p.z - offsetZ));

    // calc offset points for outside curve to find points inside the outside curve
    const offsetFrontPointsO = offsetPointsWithBufferGeometryNormal(pointsOsmooth, meshSocket.geometry, offset) // pointsOsmooth.map(p => new THREE.Vector3(p.x + offsetX, p.y, p.z + offsetZ));
    const offsetBackPointsO = offsetPointsWithBufferGeometryNormal(pointsOsmooth, meshSocket.geometry, -offset) // pointsOsmooth.map(p => new THREE.Vector3(p.x - offsetX, p.y, p.z - offsetZ));

    objects.push(<TubeCurve
      key={key}
      vpoints={offsetFrontPointsI}
      radius={0.5}
      color={colorHigh}
      />);
    key += 1;

    objects.push(<TubeCurve
      key={key}
      vpoints={offsetBackPointsI}
      radius={0.5}
      color={colorHigh}
      />);
    key += 1;

    objects.push(<TubeCurve
      key={key}
      vpoints={offsetFrontPointsO}
      radius={0.5}
      color={colorHigh}
      />);
    key += 1;

    objects.push(<TubeCurve
      key={key}
      vpoints={offsetBackPointsO}
      radius={0.5}
      color={colorHigh}
      />);
    key += 1;
    
    const sideGeometryI = sideSurfaceGeometryfromTwoCurves(offsetFrontPointsI, offsetBackPointsI);
    const meshPointsI = new THREE.Mesh(sideGeometryI, materialWireframe);
    
    objects.push(<primitive key={key} object={meshPointsI} />);
    key += 1;

    const sideGeometryO = sideSurfaceGeometryfromTwoCurves(offsetFrontPointsO, offsetBackPointsO);
    const meshPointsO = new THREE.Mesh(sideGeometryO, materialWireframe);
    
    objects.push(<primitive key={key} object={meshPointsO} />);
    key += 1;



    // const backGeometry = closedSurfaceGeometryfromCurve(offsetBackPointsI);
    // const closedMesh = new THREE.Mesh(backGeometry, materialWireframe);
    // objects.push(<primitive key={key} object={closedMesh} />);
    // key += 1;

    // const frontGeometry = closedSurfaceGeometryfromCurve(offsetFrontPointsI);
    // const frontMesh = new THREE.Mesh(frontGeometry, materialWireframe);
    // objects.push(<primitive key={key} object={frontMesh} />);
    // key += 1;
    


    const offsetPointsI = offsetFrontPointsI.concat(offsetBackPointsI);

    // CAUTION: ConvexGeometry is non-indexed geometry
    // Extract the points inside the inside curve
    const geomPointsI = new ConvexGeometry( new THREE.CatmullRomCurve3(offsetPointsI, true).getSpacedPoints(divCurvePoints));
    //const meshPointsI = new THREE.Mesh( geomPointsI, materialHigh );

    const offsetPointsO = offsetFrontPointsO.concat(offsetBackPointsO);

    // CAUTION: ConvexGeometry is non-indexed geometry
    // Extract the points inside the outside curve
    const geomPointsO = new ConvexGeometry( new THREE.CatmullRomCurve3(offsetPointsO, true).getSpacedPoints(divCurvePoints));
    //const meshPointsO = new THREE.Mesh( geomPointsO, materialHigh );
  
    // objects.push(<primitive key={key} object={meshPointsI} />);
    // key += 1;

    // judge inside/outside
    let raycaster = new THREE.Raycaster();
    let direction = new THREE.Vector3(1, 0, 0); // ray direction
    let maxWeight = 0;
    const pointsInside = [];
    const idxPointsInsideCurve = [];

    const socketPoints = meshSocket.geometry.attributes.position.array;

    // https://www.geogebra.org/m/pnmts2xu
    const A = new THREE.Vector2(0, 0);
    const B = new THREE.Vector2(0.5, 0);
    const C = new THREE.Vector2(0.5, 1);
    const D = new THREE.Vector2(1, 1);
    const bezierCurve = new THREE.CubicBezierCurve(A, B, C, D);
    
    for (let j = 0; j < meshSocket.geometry.attributes.position.array.length; j+=3) {
      const point = new THREE.Vector3(socketPoints[j], socketPoints[j+1], socketPoints[j+2]);
      const closestPointInside = findClosestPointOnPoints(pointsIsmooth, point);
      const closestPointOutside = findClosestPointOnPoints(pointsOsmooth, point);
      const distInside = closestPointInside.point.distanceTo(point);
      const distOutside = closestPointOutside.point.distanceTo(point);

      if (distInside > distOutside) {
        continue;
      }

      // calc vector from point to closestPointInside
      const vector = new THREE.Vector3().subVectors(closestPointOutside.point, point).normalize();

      raycaster.set(point, vector);
      const intersectsO = raycaster.intersectObject(meshPointsO);
      const intersectsI = raycaster.intersectObject(meshPointsI);
      
      if (intersectsO.length % 2 == 1) { // if it is odd number, it is inside of the outside curve
        pointsInside.push(point);

        let weight = 0; // initialize weight

        if (intersectsI.length % 2 == 1) { // if it is odd number, it is inside of the inside curve
          //const distInner = findClosestPointOnPoints(pointsIsmooth, point).point.distanceTo(point);
          //const distOuter = findClosestPointOnPoints(pointsOsmooth, point).point.distanceTo(point);
          //weight = bezierCurve.getPoint(distInner / (distOuter)).y;
          //weight = 0.55; // for inside point
          idxPointsInsideCurve.push(j);
          continue

        } else { // if it is even number, it is between inside and outside curve
          // calc moving depth weight
          const distInner = findClosestPointOnPoints(pointsIsmooth, point).point.distanceTo(point);
          const distOuter = findClosestPointOnPoints(pointsOsmooth, point).point.distanceTo(point);
          //weight = distOuter / (distInner + distOuter);
          //weight = bezierCurve.getPoint(1 - (distInner / (distInner + distOuter))).y;
          weight = bezierCurve.getPoint(distOuter / (distInner + distOuter)).y;

          if (weight > maxWeight) {
            maxWeight = weight;
          }
        }

        // move point
        if ( normal ) {
          meshSocket.geometry.attributes.position.array[j] += meshSocket.geometry.attributes.normal.array[j] * weight * depth;
          meshSocket.geometry.attributes.position.array[j+1] += meshSocket.geometry.attributes.normal.array[j+1] * weight * depth;
          meshSocket.geometry.attributes.position.array[j+2] += meshSocket.geometry.attributes.normal.array[j+2] * weight * depth;
        } else {
          meshSocket.geometry.attributes.position.array[j+2] += weight * depth;
        }
      }
    }
    console.log(normal)
    // move idxPointsInsideCurve
    for (let j = 0; j < idxPointsInsideCurve.length; j++) {
      const idx = idxPointsInsideCurve[j];
      if (normal) {
        meshSocket.geometry.attributes.position.array[idx] += meshSocket.geometry.attributes.normal.array[idx] * maxWeight * depth;
        meshSocket.geometry.attributes.position.array[idx+1] += meshSocket.geometry.attributes.normal.array[idx+1] * maxWeight * depth;
        meshSocket.geometry.attributes.position.array[idx+2] += meshSocket.geometry.attributes.normal.array[idx+2] * maxWeight * depth;
      } else {
        meshSocket.geometry.attributes.position.array[idx+2] += maxWeight * depth;
      }
    }
  }
  
  meshSocket.geometry.attributes.position.needsUpdate = true;
  callback(meshSocket) // disable modify mode

  // When you want to render something, you need to disable callback
  return (
    (objects.length > 0) ? (
      <group>
        {objects}
      </group>
    ) : null
  )

  // return (
  //   <>
  //     { <TubeCurve vpoints={[new THREE.Vector3(100,100,0), new THREE.Vector3(-100,-100,0)]} color={colorSub} nPoint={100} radius={10} close={true} depthTest={false} />}
  //   </>
  // )

  //return null;
});